import { isEqual, startOfDay, subDays, addDays, differenceInDays } from 'date-fns'
import { Holiday } from '@/views/TicketCheckoutViews/ShowtimesView/components/HolidayDates/holidayConstants'

export type DateType = 'limited' | 'dayBeforeRelease' | 'special' | 'normal' | 'holiday'

export function getDayBefore(inputDate: Date): Date {
  return subDays(inputDate, 1)
}

export function getDateAfterDays(inputDate: Date, days: number = 60) {
  const futureDate = new Date(inputDate)
  futureDate.setDate(inputDate.getDate() + days)
  return futureDate
}

export function generateDates(startDate: Date, endDate: Date, maxDaysToShow: number = 30): Date[] {
  const daysDiff = differenceInDays(endDate, startDate)
  const daysToGenerate = Math.min(Math.max(daysDiff, 0), maxDaysToShow)

  return Array.from({ length: daysToGenerate }, (_, i) => addDays(startDate, i))
}

export const getDateType = (
  date: Date,
  specialDate?: Date,
  limitedEventDate?: Date | null,
  releaseDate?: Date,
  holiday?: Holiday | null,
): DateType => {
  const dateStart = startOfDay(date)

  if (limitedEventDate && isEqual(dateStart, startOfDay(limitedEventDate))) return 'limited'
  if (releaseDate && isEqual(dateStart, startOfDay(getDayBefore(releaseDate))) && !specialDate)
    return 'dayBeforeRelease'
  if (holiday) return 'holiday'
  if (specialDate && isEqual(dateStart, startOfDay(specialDate))) return 'special'
  return 'normal'
}
